<template>
  <div>
    <b :class="[getValueTextClass()]" v-if="status == 'p'" style="font-size: 16px">{{ value | decimal }}</b>
    <s :class="'text-muted'" v-else>{{ value | decimal }}</s>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    paymentMethod: {},
    status: {},
  },

  methods: {
    getValueTextClass() {
      if (this.paymentMethod != 1) {
        return "text-muted";
      }

      if (this.value >= 0) {
        return "text-success";
      } else {
        return "text-danger";
      }
    },
  },
};
</script>

<style>
</style>